import { render } from "./MyCompanyName_CH.vue?vue&type=template&id=119a1232"
import script from "./MyCompanyName_CH.vue?vue&type=script&lang=js"
export * from "./MyCompanyName_CH.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__